/*
 * @Author: edvardchen
 * @Date:   2016-11-29 16:48:24
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2017-05-04 17:23:27
 */
import React from 'react';
import PropTypes from 'prop-types';

import './DBMask.scss';

import steyles from '../../containers/base.scss';

const Mask = ({ onClose, onDownload }) => (
  <div className="mod-pushmask">
    <div className="bg"></div>
    <span className={`close ${steyles.closeIcon}`} onClick={onClose} />
    <div className="mod-view--all" onClick={onDownload}>
      <a href="javascript:">下载QQ浏览器</a>
    </div>
  </div>
);
Mask.propTypes = {
  onClose: PropTypes.func,
  onDownload: PropTypes.func,
};

export default Mask;
